var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-container"},[_c('img',{style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }